import React from 'react';
import ReactMarkdown from 'react-markdown';
import { ButtonVariant, EnumTooltipPosition, IconButton, Tooltip } from 'react-magma-dom';
import { StyledCustomLessonIcon, StyledLessonIcon } from '../../Styled';
import { getLessonIcon, getLessonIconTooltipContent } from '../../../utils';
import { LessonPageIcon, LessonPageLinkType } from '../../../types/lessons';

interface ILessonIcon {
  icon: LessonPageIcon | LessonPageLinkType | 'arrow';
  color?: string;
  isTooltipShown?: boolean;
  isCustom?: boolean;
  margin?: string;
}

export const LessonIcon: React.FC<ILessonIcon> = props => {
  const { icon, color, isTooltipShown, isCustom, margin } = props;

  const iconComponent = getLessonIcon(icon, color);

  return (
    <StyledLessonIcon margin={margin}>
      {isTooltipShown ? (
        <Tooltip
          isInverse
          position={EnumTooltipPosition.right}
          content={<ReactMarkdown skipHtml={false}>{getLessonIconTooltipContent(icon)}</ReactMarkdown>}
          tooltipStyle={{
            boxShadow: '0 4px 4px 0 rgba(0, 0, 0, 0.15)',
            fontFamily: 'Lexend',
            fontSize: '10px',
            fontWeight: 500,
            lineHeight: 'normal',
            letterSpacing: 'normal',
            marginLeft: isCustom ? '-11px' : '',
          }}
          containerStyle={{
            display: 'inline-flex',
          }}
          testId="lesson-icon-tooltip"
        >
          {isCustom ? (
            <StyledCustomLessonIcon aria-label={icon} color={color}>
              {iconComponent}
            </StyledCustomLessonIcon>
          ) : (
            <IconButton aria-label={icon} icon={iconComponent} variant={ButtonVariant.link} />
          )}
        </Tooltip>
      ) : (
        iconComponent
      )}
    </StyledLessonIcon>
  );
};
